import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserDetailService } from '../services/user-detail.service';
import { AuthService } from '../services/auth.service';
import {AppRoutes} from './app-routes';

export const roleAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const userDetailService = inject(UserDetailService);
  const router = inject(Router);

  const currentUrl = state.url;
  const allowedRoles: string[] | undefined = route.data?.['roles'];
  const userRole = userDetailService.role;
  const isLoggedIn = authService.loggedIn.value;
  const isAccountAdmin = userDetailService.isAccountAdmin;

  const isNoPermission = currentUrl.startsWith(AppRoutes.NO_PERMISSION);

  if (isNoPermission) return true;
  if (!isLoggedIn) return router.createUrlTree([AppRoutes.LOGIN]);

  const runRoleChecks = () => {
    const isUnauthorizedRole =
      allowedRoles && (!userRole || !allowedRoles.includes(userRole));
    const isRestrictedSettingsAccess =
      !isAccountAdmin && currentUrl.includes(AppRoutes.SETTING);

    if (isUnauthorizedRole || isRestrictedSettingsAccess) {
      localStorage.setItem('attemptedUrl', currentUrl);
      if (isRestrictedSettingsAccess) {
        return router.createUrlTree([AppRoutes.NO_PERMISSION], {
          queryParams: { reasonAdmin: 'Musíš byť admin aby si sem mal prístup.' },
        });
      }
      return router.createUrlTree([AppRoutes.NO_PERMISSION]);
    }
    return true;
  };

  return runRoleChecks();
};
